import { func } from "prop-types";
import Modal from "@shared/v2/Modal";
import Button from "@shared/v2/Button/Button";
import Spinner from "@shared/v2/Icomoon/Icons/Spinner";

const SpinnerModal = ({ closeOptionsModal }) => (
  <Modal
    className="tw-flex tw-justify-center tw-items-center"
    dialogClassName="!tw-w-[616px] tw-h-auto"
    contentClassName="tw-w-full tw-h-full"
    backdrop="static"
    show
    onHide={closeOptionsModal}
  >
    <Modal.Header titleClassName="tw-mb-32px tw-text-gray-75" title="" closeButton />

    <Modal.Body>
      <div className="tw-h-[70px] tw-flex tw-justify-center tw-items-center">
        <Spinner size="xxxl" className="fa-spin" />
      </div>
    </Modal.Body>
    <Modal.Footer className="tw-flex tw-flex-row tw-justify-end">
      <Button size="medium" schema="tertiary" onClick={closeOptionsModal}>
        Close
      </Button>
    </Modal.Footer>
  </Modal>
);

SpinnerModal.propTypes = {
  closeOptionsModal: func,
};

SpinnerModal.defaultProps = {
  closeOptionsModal: null,
};
export default SpinnerModal;
